import "./ScheduleExceptions.html";
import "./ScheduleExceptions.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ScheduleExceptionsComponentController from "./ScheduleExceptionsComponentController";

export default class ScheduleExceptionsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            changed: "&?",
            configurationGroup: "=",
            customHeader: "@",
            groupTypeName: "@",
            hideHints: "=",
            isDisabled: "@",
            schedule: "=",
            site: "=",
        };
        this.controller = ScheduleExceptionsComponentController;
        this.templateUrl = "/App/Components/Forms/ScheduleExceptions/ScheduleExceptions.html";
    }
}

module("mmManagePortal").component("irScheduleExceptions", new ScheduleExceptionsComponent());
